<template>
  <div class="battle">
    <div class="battle__header" flex="main:center cross:center" :style="{height:headerHeight}">
      <span>支付系统作战地图</span>
    </div>

    <div class="battle__container">
      <el-row :gutter="10">
        <el-col :span="7">
          <Info :height="infoHeight"></Info>
          <div class="battle__space" :style="{height:spaceHeight}"></div>
          <LineChart></LineChart>
          <div class="battle__space" :style="{height:spaceHeight}"></div>
          <el-row :gutter="10">
            <el-col :span="12">
              <PieChart></PieChart>
            </el-col>
            <el-col :span="12">
              <RingChart></RingChart>
            </el-col>
          </el-row>
          <div class="battle__space" :style="{height:spaceHeight}"></div>
          <HistogramChart></HistogramChart>
        </el-col>
        <el-col :span="10">
          <MapChart></MapChart>
          <div class="battle__space" :style="{height:spaceHeight}"></div>
          <List></List>
        </el-col>
        <el-col :span="7">
          <Info></Info>
          <div class="battle__space" :style="{height:spaceHeight}"></div>
          <LineChart></LineChart>
          <div class="battle__space" :style="{height:spaceHeight}"></div>
          <HeatmapChart></HeatmapChart>
          <div class="battle__space" :style="{height:spaceHeight}"></div>
          <HistogramChart></HistogramChart>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import Info from './components/Info/'
import List from './components/List/'
import LineChart from './components/lineChart/'
import PieChart from './components/pieChart/'
import RingChart from './components/ringChart/'
import HeatmapChart from './components/heatmapChart/'
import HistogramChart from './components/histogramChart/'
import MapChart from './components/mapChart/'
export default {
  components: {
    Info,
    List,
    MapChart,
    LineChart,
    PieChart,
    RingChart,
    HeatmapChart,
    HistogramChart
  },
  data () {
    let clientHeight = document.body.clientHeight
    function getValue (per) {
      return (per * clientHeight) / 100 + 'px'
    }
    return {
      spaceHeight: getValue(1),
      headerHeight: getValue(8),
      infoHeight: getValue(11)
    }
  }
}
</script>

<style lang="scss">
@import "./style.scss";
</style>
